export const ImportFieldType = {
  IGNORE: 1,
  EMAIL: 2,
  FIRST_NAME: 3,
  LAST_NAME: 4,
  COUNTRY: 5,
  CITY: 6,
  EMAIL_SUBSCRIPTION_STATUS: 8,
  LANGUAGE: 10,
  PHONE: 12,
  TAGS: 13,
  SMS_SUBSCRIPTION_STATUS: 14,
  EMAIL_SUBSCRIPTION_CONFIRMATION_DATE: 16,
  GENDER: 17,
  BIRTH_DATE: 18,
  FULL_NAME: 19,
  WHATSAPP_SUBSCRIPTION_STATUS: 20,
};
